import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconX: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M225.848889 225.848889a42.666667 42.666667 0 0 1 60.302222 0L512 451.697778l225.848889-225.848889a42.666667 42.666667 0 1 1 60.302222 60.302222L572.302222 512l225.848889 225.848889a42.666667 42.666667 0 1 1-60.302222 60.302222L512 572.302222l-225.848889 225.848889a42.666667 42.666667 0 1 1-60.302222-60.302222L451.697778 512 225.848889 286.151111a42.666667 42.666667 0 0 1 0-60.302222z"
    />
);